import { render, staticRenderFns } from "./documents-table-status-badge.vue?vue&type=template&id=4f951f54&"
import script from "./documents-table-status-badge.vue?vue&type=script&lang=js&"
export * from "./documents-table-status-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports